export class Pais {
    pais_cod: number;
    pais_nom: string;

    id: number;
    text: string;

    constructor() {
    }

    static fromJson(data) {
        const pais = Object.assign(new Pais(), data);

        pais.id = pais.pais_cod;
        pais.text = pais.pais_nom.replace('<', '').replace('>', '');

        return pais;
    }
}



// WEBPACK FOOTER //
// ./src/app/_shared/endereco/pais.ts